import { notification } from 'antd'

const AntNotificationStyled = notification
export default AntNotificationStyled
